
import './App.css';
import Homemain from './Pages/Home/Homemain';
import { Route,Routes } from 'react-router-dom';
// import PropertyDetails from './Pages/PropertyDetails/DetailsMain.jsx';
import RentalSearchResults from './Pages/Search_Result_Page/RentalSearchResults.jsx';
import Navbar from './Pages/Common Component/Navber.jsx';
import Footer from './Pages/Home/Footer.jsx';
import RentalDetails from './Pages/Rental_Details/Rental_Property_Details.jsx';
import BookingForm from './Pages/BookingPages/BookingForm.jsx';
import Login from './Pages/Login/Login.jsx';
import Registration from './Pages/Login/Registration.jsx';
import Profile from './Pages/Profile/Profile.jsx';
import { Toaster } from 'sonner';

function App() {

  return (
    <div className="App">
      <Toaster richColors closeButton position="top-right" />
      <Routes>
    <Route path='/' element={  <Homemain/>}/>
     <Route path='/login' element={<Login/>}/>
      <Route path='/register' element={  <Registration/>}/>
       <Route path='/profile' element={  <Profile/>}/>
    <Route path='/rental-details/:id' element={  <RentalDetails/>}/>
    <Route path='/search-results' element={  <RentalSearchResults/>}/>
    <Route path='/booking-form' element={  <BookingForm/>}/>
    
      </Routes>
   
    </div>
  );
}

export default App;
